<template>
  <div>
    <div class="additional">
      <div class="additional-header">{{ $t("ORDER.PAY_BY_REVOLUT") }}</div>
      <div class="revolut-placeholder">
        <div class="widget" @click="handleRevolutPayment">
          <img src="@/assets/revolut-logo.png" />
        </div>
      </div>
      <modal-loader v-model="modalLoader" />
    </div>
  </div>
</template>

<script>
import RevolutCheckout from "@revolut/checkout";
import ModalLoader from "@/components/common/ModalLoader.vue";
import { WIDGET_TYPE } from "@/3c.config";
import { getPaymentMethods } from "../../services/payments";

export default {
  name: "Revolut",
  props: { order: Object },
  components: { ModalLoader },
  data() {
    return {
      modalLoader: false
    };
  },
  methods: {
    async handleRevolutPayment() {
      const token = await this.getToken();

      try {
        RevolutCheckout(token).then(instance => {
          instance.payWithPopup({
            name: this.order.shipaddressee,
            billingAddress: {
              countryCode: this.order.billcountry,
              city: this.order.billcity,
              postcode: this.order.billzip,
              streetLine1: this.order.billaddressee,
              streetLine2: `${this.order.billaddress} ${this.order.billaddress2}`
            },
            onSuccess: () => this.$emit("success", { status: "COMPLETED" }),
            onError(message) {
              alert(message);
            }
          });
        });
      } catch (error) {
        this.$emit("error", error);
      }
    },
    async getToken() {
      const res = await getPaymentMethods({
        currency: this.order?.currency?.iso,
        amount: this.order?.grossamount * 100,
        transactionid: this.order?._id
      });
      const revolutMethod = res.data.find(
        method => method.widgettype === WIDGET_TYPE.REVOLUT
      );
      return revolutMethod?.token[0]?.service?.token || "";
    }
  }
};
</script>

<style lang="scss" scoped>
.additional {
  .additional-header {
    background-color: black;
    color: white;
    padding: 5px 15px;
    font-family: "Michroma", sans-serif;
    font-size: 14px;
    margin: 20px 0;
  }

  .revolut-placeholder {
    height: 150px;
    width: auto;

    .widget,
    img {
      height: 150px;
    }
    .widget {
      display: flex;
      justify-content: center;
    }
    img:hover {
      cursor: pointer;
      filter: brightness(80%);
    }
  }
}
</style>
